var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOutreachService = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#FC5959"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.627 7.333c-.418 0-.776-.15-1.075-.447a1.46 1.46 0 0 1-.448-1.073c0-.417.149-.775.446-1.074a1.46 1.46 0 0 1 1.073-.448c.418 0 .776.149 1.075.446.298.298.448.655.448 1.073 0 .418-.149.776-.446 1.075a1.46 1.46 0 0 1-1.073.448zm-2.231 13.625V9.854a40.906 40.906 0 0 1-2.74-.292 26.84 26.84 0 0 1-2.531-.48l.312-1.25a27.41 27.41 0 0 0 3.521.594c1.167.118 2.39.178 3.667.178 1.278 0 2.5-.06 3.667-.178a27.412 27.412 0 0 0 3.52-.593l.313 1.25c-.806.194-1.65.354-2.531.479-.882.125-1.795.223-2.74.294v11.102h-1.25V15.54h-1.958v5.417h-1.25z"
})));
export { SvgOutreachService as ReactComponent };
export default __webpack_public_path__ + "images/outreach-service.svg";